import $ from 'jquery';

const $target = $('#ajax-target');
const $buttons = $('.ajax-lehrplan');
let lastLoadingUrl = null;

$buttons.on('click', ev => {
    ev.preventDefault();
    const $link = $(ev.currentTarget);

    $buttons.removeClass('button--primary');
    $buttons.addClass('button--none');

    $link.removeClass('button--none');
    $link.addClass('button--primary');

    const href = $link.attr('href');
    lastLoadingUrl = href;

    (async () => {
        const backupHtml = $target.html();

        $target.html(`
            <div class="container">
                <div class="d-flex justify-content-center py-10">
                    <div class="spinner-border" role="status">
                        <span class="visually-hidden">Lädt...</span>
                    </div>
                </div>
            </div>
        `);

        let resp = await fetch(href);
        let html = await resp.text();

        if (lastLoadingUrl !== href) {
            // aborted.
            return;
        }

        window.history.pushState({}, '', href);


        let $content = $(html.split('<!-- LEHRPLAN AJAX CONTENT -->')[1]);
        if ($content.attr('id') !== 'ajax-target') {
            console.warn('Lehrplan AJAX: No #ajax-target found in response');
            $target.html(backupHtml);
            return;
        }

        let $wrap = $('<div></div>');
        $wrap.html(html);
        let title = $wrap.find('title').eq(0).text();
        $('html > head').find('title').text(title);

        $target.html($content.html());

    })();

});


/*
 * ################################################################################
 * # Draggable Lehrplan Menu                                                      #
 * # If the below causes problems, feel free to replace it with something else. #
 * ################################################################################
 */
(() => {
    let $slider = $('.lehrplan-menu__draggable');
    let $container = $slider.closest('.lehrplan-menu__container');
    let $root = $slider.closest('.lehrplan-menu');

    if ($slider.length === 0 || $container.length === 0 || $root.length === 0) {
        return;
    }

    let grabbing = false;
    let startX = 0;
    let distanceToScroll = 0;
    let cancelClickForGrabbing = false;

    $slider.find('.ajax-lehrplan').each((i, elem) => {
        elem.addEventListener('click', ev => {
            if (cancelClickForGrabbing) {
                ev.preventDefault();
                ev.stopPropagation();
                cancelClickForGrabbing = false;
            }
        }, {capture: true});
    });

    $slider.on('touchstart mousedown', ev => {
        if (ev.type === 'mousedown' && ev.which === 1) {
            // needed to prevent default grab/drag behaviour
            // but must not be used for touch events, as it prevents a regular click
            ev.preventDefault();
        }
        startX = ev.pageX || ev.touches[0].pageX - ev.currentTarget.offsetLeft;
        grabbing = true;
        distanceToScroll = 0;
    });

    $slider.on('mousemove touchmove', ev => {
        if (grabbing) {
            let newClientX = ev.pageX || ev.touches[0].pageX - ev.currentTarget.offsetLeft;
            distanceToScroll = newClientX - startX;

            let container = $container[0];
            let parentScrollPosX = container.scrollLeft;
            container.scrollLeft = parentScrollPosX - distanceToScroll;
            startX = newClientX;

            if (Math.abs(distanceToScroll) > 10) {
                cancelClickForGrabbing = true;
            }
        }
    });

    $slider.on('touchend mouseup mouseleave', ev => {
        if (grabbing) {
            distanceToScroll = 0;
            grabbing = false;
            window.setTimeout(() => {
                cancelClickForGrabbing = false;
            }, 100);
        }
    });

    let $active = $container.find('.button--primary');
    if ($active.length > 0) {
        $active[0].scrollIntoView({block: 'center', inline: 'center'});
    }

    const $buttonLeft = $(
        '<button class="icon-button icon-button--small fs-5 icon-button--primary icon-button--top-climb-small icon-button--bottom-slide slick-next">' +
        '<i class="fa-thin fa-chevron-left"></i>' +
        '</button>'
    );
    const $buttonRight = $(
        '<button class="icon-button icon-button--small fs-5 icon-button--primary icon-button--top-slide-small icon-button--bottom-climb slick-next">' +
        '<i class="fa-thin fa-chevron-right"></i>' +
        '</button>'
    );
    const $buttonWrap = $('<div class="lehrplan-menu__button-hint"></div>');

    $buttonWrap.append($buttonLeft);
    $buttonWrap.append($buttonRight);
    $root.append($buttonWrap);

    const MAX_SCROLL = 100;
    const STEP = 15;

    const checkPos = () => {
        let scrollPos = $container[0].scrollLeft;
        let sliderWidth = parseInt($slider.width()) - scrollPos;
        let remaining;
        remaining = sliderWidth - $container.width();

        $buttonRight.removeClass('invisible');
        $buttonLeft.removeClass('invisible');

        if (remaining < 2) {
            $buttonRight.addClass('invisible');
        }
        if (scrollPos < 1) {
            $buttonLeft.addClass('invisible');
        }
    };

    const anim = (start, step) => {
        let current = $container[0].scrollLeft;
        $container[0].scrollTo(current + step, 0);
        let newLeft = $container[0].scrollLeft;

        let sliderWidth = parseInt($slider.width()) - $container[0].scrollLeft;
        let remaining;

        if (step > 0) {
            remaining = Math.abs(sliderWidth - $container.width());
        } else {
            remaining = newLeft;
        }

        if (remaining > 1 && Math.abs(newLeft - start) < MAX_SCROLL) {
            window.requestAnimationFrame(() => anim(start, step));
        }
        checkPos();
    };

    $buttonLeft.on('click', () => {
        let start = $container[0].scrollLeft;
        window.requestAnimationFrame(() => anim(start, -STEP));
    });

    $buttonRight.on('click', () => {
        let start = $container[0].scrollLeft;
        window.requestAnimationFrame(() => anim(start, STEP));
    });

    window.requestAnimationFrame(() => checkPos());

})();
/*
 * Draggable Lehrplan Menu (End)
 */
